export default __webpack_public_path__ + "static/media/undefined_image.b59890b7.jpg";